@if (technicianDateCollection) {
  <div class="travel_technician_menu_container" [ngClass]="anchor + '_anchor'">
    <div
      style="display: inline-flex; flex-direction: row; font-size: 12px; line-height: 14px; flex: 1"
      class="black_gradient_background"
      [tooltip]="tooltip"
      (click)="createTravelTechnicianDate()"
    >
      <div
        style="background-size: 100%; width: 18px; height: 18px; position: relative; margin: auto"
        class="destination_background_container"
      >
        <div
          class="destination_background"
          [style.background-color]="
            PAUtil.getIndexColorString(
              PATimeControl.Instance.weekDays.indexOf(PATimeControl.Instance.getTimeStampsWeekDay(dayTimestamp))
            )
          "
          [ngClass]="this.getMarker() ? '' : 'inactive'"
        ></div>
        <div class="destination_background_border"></div>
      </div>
    </div>
    <hawk-popup-menu #TravelTechnicianPopupMenuComponent [anchor]="anchor">
      <div class="content" style="position: relative; background: #2d2d2d; cursor: auto">
        <fa-icon
          style="position: absolute; top: 0; right: 4px; color: white; cursor: pointer"
          [icon]="faWindowClose"
          (click)="popupMenu.close()"
        ></fa-icon>
        <div class="vertical_flex" style="padding: 2px 4px">
          <h6>{{ tooltip }}</h6>
          <div class="horizontal_flex">
            <div style="margin-right: 4px">Ziel: {{ getDestination() }}</div>
            @if (getMarker()?.coordinates) {
              <a
                target="_blank"
                [href]="
                  'https://www.google.de/maps/search/Hotel/@' +
                  getMarker().coordinates.latitude +
                  ',' +
                  getMarker().coordinates.longitude +
                  ',13.00z'
                "
              >
                Hotels in der Nähe
              </a>
            }
          </div>
          <div #TargetGeocoder></div>
          <div class="horizontal_flex" style="margin-top: 4px; white-space: nowrap">
            <button
              mat-raised-button
              color="primary"
              (click)="showGenerateOperationModal = true; initializeTicketFormGroup()"
            >
              Int. Auftrag erstellen
            </button>
            <button
              mat-raised-button
              color="warn"
              style="margin-left: 4px"
              (click)="deleteTravelTechnicianDate(); $event.stopPropagation()"
            >
              entfernen
            </button>
          </div>
        </div>
      </div>
    </hawk-popup-menu>
  </div>
}

<hawk-popup-modal
  [shown]="showGenerateOperationModal"
  [closeIconColor]="'black'"
  (closeEvent)="showGenerateOperationModal = false"
>
  <div style="width: 900px; background-color: #1f1f1f; border-radius: 4px">
    <form
      [formGroup]="ticketForm"
      (submit)="onTicketSubmit()"
      class="page-sheet w-full max-w-5xl mx-auto grid grid-cols-3"
      style="color: black; padding-top: 26px"
    >
      <div class="bm-card bm-card-sm">
        <fieldset class="bm-card-body">
          <h2 class="bm-card-title">Auftrags-Daten</h2>
          <label class="bm-fieldset-label">Projekt*</label>
          <select
            class="bm-select w-full"
            formControlName="project_id"
            [disabled]="true"
            [value]="ticketForm.controls['project_id'].value"
          >
            <option>None</option>
            @for (project of PADataControl.Instance.loadedProjects; track project) {
              <option [value]="project.id">{{ project.project_name }}</option>
            }
          </select>
          <label class="bm-fieldset-label">Priorität*</label>
          <select class="bm-select w-full" formControlName="priority_id">
            <option>None</option>
            @for (
              priority of PADataControl.Instance.getProject(ticketForm.get("project_id").value)?.priorities;
              track priority
            ) {
              <option [value]="priority.id">{{ priority.name }}</option>
            }
          </select>

          <label class="bm-fieldset-label">Status*</label>
          <select class="bm-select w-full" formControlName="status_id" [disabled]="!ticketForm.get('project_id').value">
            <option>None</option>
            @for (
              status of PADataControl.Instance.getProject(ticketForm.get("project_id").value)?.status;
              track status
            ) {
              <option [value]="status.id">{{ status.label || status.name }}</option>
            }
          </select>

          <label class="bm-fieldset-label">Beschreibung</label>
          <textarea
            class="bm-textarea"
            spellcheck="false"
            formControlName="description"
            placeholder="Beschreibung hinzufügen..."
          ></textarea>
        </fieldset>
      </div>
      <section class="bm-card bm-card-sm">
        <fieldset class="bm-card-body relative">
          <h2 class="bm-card-title">Hotel-Adresse</h2>

          <div class="absolute" style="top: -18px; right: 18px" id="address_geocoder" #TicketFormGeocoder></div>
          <label class="bm-fieldset-label">Hotel-Name</label>
          <input class="bm-input w-full" formControlName="address_name" />

          <label class="bm-fieldset-label">Straße</label>
          <div class="flex flex-row w-full">
            <input class="bm-input flex-3" formControlName="address_street" />
            <input class="bm-input flex-1" formControlName="address_street_no" />
          </div>

          <label class="bm-fieldset-label">PLZ / Ort</label>
          <div class="flex flex-row w-full">
            <input class="bm-input flex-1" formControlName="address_zip" placeholder="PLZ" />
            <input class="bm-input flex-2" formControlName="address_city" />
          </div>

          <label class="bm-fieldset-label">Land / Staat </label>
          <div class="flex flex-row w-full">
            <input class="bm-input flex-1" formControlName="address_country" placeholder="Land" />
            <input class="bm-input flex-1" formControlName="address_state" placeholder="Staat" />
          </div>

          <label class="bm-fieldset-label">Koordinaten</label>
          <div class="flex flex-row w-full">
            <input class="bm-input flex-1" formControlName="address_latitude" placeholder="Breite" />
            <input class="bm-input flex-1" formControlName="address_longitude" placeholder="Länge" />
          </div>
        </fieldset>
      </section>

      <section class="bm-card bm-card-sm">
        <fieldset class="bm-card-body">
          <h2 class="bm-card-title">Kontakt-Daten (optional)</h2>

          <label class="bm-fieldset-label">Name</label>
          <input class="bm-input w-full" formControlName="contact_name" />

          <label class="bm-fieldset-label">Telefon</label>
          <input class="bm-input w-full" formControlName="contact_phone" />

          <label class="bm-fieldset-label">E-Mail</label>
          <input class="bm-input w-full" formControlName="contact_email" />
        </fieldset>
      </section>

      <div class="flex flex-row gap-3 col-span-3 justify-end">
        <button class="bm-btn bm-btn-primary" [disabled]="ticketForm.invalid">Speichern</button>
      </div>
    </form>
  </div>
</hawk-popup-modal>
